<template>
  <div class="details text-light flex-column">
    <div class="background bg-1">
      <img :src="require(`@/assets/capas/${category}.webp`)">
    </div>
    <header>
      <div class="title title-1">{{ product ? product.name : '' }}</div>
    </header>
    <div class="content flex-column align-center">
      <div class="flex align-center justify-space-between" style="flex-wrap: wrap; width: 100%;gap: 7vw">
        <div class="image-view flex justify-space-between align-center" v-if="product">
          <div class="small-images flex-column">
            <img style="cursor: pointer; max-height: 20vw" @click="changeImg(0)" :src="getProductImage(0)" width="120" alt="">
            <img style="cursor: pointer; max-height: 20vw" @click="changeImg(1)" :src="getProductImage(img1)" width="120" alt="">
            <img style="cursor: pointer; max-height: 20vw" @click="changeImg(2)" :src="getProductImage(img2)" width="120" alt="">
          </div>
          <ImagemZoom
            :src="getProductImage(number_img)"
            :src-large="getProductImage(number_img)"
          />
        </div>
        <div class="details-content flex-column justify-space-between text-tertiary" v-if="product">
          <div class="title-2">{{ product.name }}</div>
          <div class="product-details body-2">
            <div class="body-4" v-for="(line, index) in product.measures" :key="index">{{ line }}</div>
          </div>
          <div class="actions flex-column align-center">
            <button class="btn-primary" @click="$router.push({ name: 'WhereBuy' })">Onde Comprar</button>
            <button class="btn-outlined" @click="$router.push({ name: 'Representatives' })">Revender esse produto</button>
          </div>
        </div>
      </div>
      <div v-if="product && product.descriptions && product.descriptions.length > 0" class="flex-column align-left text-tertiary" style="gap: 3px">
        <div class="subtitle-1">ESPECIFICAÇÕES:</div>
        <div class="body-3" v-for="(line, index) in product.descriptions" :key="index">{{ line }}</div>
      </div>
      <div class="see-too flex-column align-center text-tertiary">
        <span class="title-1 flex">Veja também</span>
        <div class="flex justify-center" style="flex-wrap: wrap">
          <div v-for="(relatedProduct, index) in ramdomProducts" :key="index" @click="scrollToTop()" class="flex-column align-center justify-center ramdom-products">
            <router-link :to="{ name: 'Details', params: { id: getProductIndex(relatedProduct), categoria: $route.params.categoria } }">
              <img :src="getRelatedProductImage(relatedProduct)" width="130" alt="">
            </router-link>
            <div class="body-2">{{ relatedProduct.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImagemZoom from '@/components/ImageZoom'
import api from '@/services/api'

export default {
  name: 'Details',
  components: {
    ImagemZoom
  },
  data () {
    return {
      loading: true,
      product_image_zoom: '',
      number_img: 0,
      // Dados da API
      apiProduct: null,
      apiRelatedProducts: []
    }
  },
  async created () {
    await this.fetchProductDetails()
  },
  mounted () {
    if (this.product) {
      this.product_image_zoom = this.product.name
    }
  },
  watch: {
    // Quando mudar o produto (via "Veja também"), recarrega
    '$route.params.id': {
      handler () {
        this.number_img = 0
        this.fetchProductDetails()
      }
    }
  },
  computed: {
    product () {
      // Usa dados da API (null se não retornar)
      if (this.apiProduct) {
        return {
          name: this.apiProduct.name,
          slug: this.apiProduct.slug,
          measures: this.apiProduct.measures || [],
          descriptions: this.apiProduct.specifications || [],
          images: this.apiProduct.images || [],
          primaryImage: this.apiProduct.primaryImage
        }
      }
      return null
    },
    category () {
      return this.$route.params.categoria
    },
    ramdomProducts () {
      // Usa dados da API (vazio se não retornar)
      return this.apiRelatedProducts.map(p => ({
        name: p.name,
        slug: p.slug,
        primaryImageUrl: p.primaryImage?.url || null
      }))
    },
    // Imagens do produto (da API)
    productImages () {
      if (this.product?.images?.length > 0) {
        return this.product.images.map(img => img.url)
      }
      return []
    },
    img1 () {
      return this.productImages.length > 1 ? 1 : 0
    },
    img2 () {
      return this.productImages.length > 2 ? 2 : 0
    }
  },
  methods: {
    async fetchProductDetails () {
      this.loading = true
      try {
        // Busca por slug na API
        const productId = this.$route.params.id
        const data = await api.getProductDetails(this.$route.params.categoria, productId)
        if (data) {
          this.apiProduct = data.product
          this.apiRelatedProducts = data.relatedProducts || []
        }
      } catch (error) {
        console.error('Erro ao carregar detalhes do produto:', error)
        // Mantém null se API falhar
        this.apiProduct = null
        this.apiRelatedProducts = []
      } finally {
        this.loading = false
        if (this.product) {
          this.product_image_zoom = this.product.name
        }
      }
    },
    getProductImage (index) {
      // Usa imagem da API (vazio se não tiver)
      return this.productImages[index] || ''
    },
    getRelatedProductImage (product) {
      // Usa URL da API (vazio se não tiver)
      return product.primaryImageUrl || ''
    },
    getProductIndex (product) {
      return product.slug || ''
    },
    changeImg (number) {
      this.number_img = number
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.details {
  justify-content: start;
  position: relative;
  scroll-behavior: smooth;
  .content {
    max-width: 1441px;
    margin: 0 auto;
    justify-content: start;
    gap: 50px !important;
  }
  .body-3 {
    text-align: left;
  }
  button {
    min-width: 250px;
  }
  .flex, .flex-column {
    gap: 20px;
  }
  .details-content {
    gap: 20px !important;
    margin: 0 auto;
    .title-2 {
      max-width: 250px;
    }
  }
  @media screen and (max-width: 925px){
    .image-view {
      margin: 30px auto;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 0px;
    }
    .small-images {
      flex-direction: row;
    }
    .details-content {
      gap: 20px !important;
    }
  }
  @media screen and (max-width: 409px){
    .image-view {
      margin: 30px auto;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 0px;
    }
    .small-images {
      gap: 14px;
      img {
        width: 90px;
      }
    }
  }
  .details-content {
    gap: 30px;
    text-align: left;
  }
  .ramdom-products {
    max-width: 180px;
  }
}
.details header{
  padding: 40px 80px;
  margin-top: 50px;
  margin-bottom: 13vw;
  text-align: left;
}
@media screen and (max-width: 425px){
  .details header{
    padding: 40px 40px;
  }
  #content {
    margin: 0 0;
  }
}
.details .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: 0;
  width: 120vw;
  min-height: 430px;
  max-height: 430px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
  img {
    width: 103%;
    margin-top: -90px;
  }
}
@media screen and (max-width: 930px) {
  .details .background {
    img {
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 730px) {
  .details .background {
    img {
      margin-top: 80px;
    }
  }
}
@media screen and (max-width: 575px) {
  .details .background {
    img {
      width: 120%;
      min-width: 664px;
      margin-left: -30px;
      margin-top: 100px;
    }
  }
}
</style>